import { Link } from 'react-router-dom';

interface ComicCardProps {
  slug: string;
  title: string;
  cover: string;
  status: string;
  rating: number;
  chapters: number;
  tags: string[];
  isNew?: boolean;
  isHot?: boolean;
  updatedAt?: string;
}

export default function ComicCard({
  slug,
  title,
  cover,
  status,
  rating,
  chapters,
  tags,
  isNew,
  isHot,
  updatedAt,
}: ComicCardProps) {
  return (
    <Link
      to={`/comic/${slug}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={cover}
          alt={title}
          title={`${title} - 韩国漫画 在线免费阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-2 left-2 flex flex-col gap-1">
          {isNew && (
            <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
              新
            </span>
          )}
          {isHot && (
            <span className="px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
              热门
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
            status === '连载中' ? 'bg-accent-100 text-accent-800' : 'bg-secondary-100 text-secondary-800'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
          <div className="flex items-center gap-2 text-background-50 text-xs">
            <div className="flex items-center gap-0.5">
              <i className="ri-star-fill text-accent-400 text-xs"></i>
              <span>{rating}</span>
            </div>
            <span className="opacity-60">共{chapters}话</span>
          </div>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
          {title}
        </h3>
        <div className="flex flex-wrap gap-1 mt-2">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs"
            >
              {tag}
            </span>
          ))}
        </div>
        {updatedAt && (
          <p className="mt-2 text-xs text-foreground-500">
            更新于 {updatedAt}
          </p>
        )}
      </div>
    </Link>
  );
}